import { Mandant, MandantSettings, ThemeName, themeNames } from './types';
import { mandantSettings } from '../Settings/mandants/mandant-settings';
import { getDefaultOriginMandantSettings, getMandantSettingsByDomain } from './providers/state-provider-utils';

export const getMandantSettingsByUsername = (username: string): MandantSettings => {
  if (!username) return getDefaultOriginMandantSettings();
  const splittedUsername: string[] = username.split('@');
  if (splittedUsername.length < 2) return getDefaultOriginMandantSettings();
  const mandantSetting: MandantSettings = getMandantSettingsByDomain(splittedUsername[1]);
  return mandantSetting ?? getDefaultOriginMandantSettings();
};

export const getMandantSettingsByMandant = (mandant: Mandant): MandantSettings => {
  if (!mandant) return getDefaultOriginMandantSettings();
  const mandantSetting: MandantSettings = mandantSettings.find((ms: MandantSettings): boolean => ms.mandant === mandant);
  return mandantSetting ?? getDefaultOriginMandantSettings();
};

export function getThemeName(themeName: string, defaultTheme: ThemeName = null): ThemeName {
  if (!!themeName && -1 !== themeNames.findIndex((n: ThemeName): boolean => n === themeName)) {
    return themeName;
  }
  return defaultTheme;
}

export function getMandantSettingsByTopOrga(topOrga: string): MandantSettings {
  return mandantSettings.find((ms: MandantSettings) => ms.topOrga === topOrga);
}
